import { render, staticRenderFns } from "./IconInstagram.vue?vue&type=template&id=b53138b6&scoped=true&"
import script from "./IconInstagram.vue?vue&type=script&lang=js&"
export * from "./IconInstagram.vue?vue&type=script&lang=js&"
import style0 from "./IconInstagram.vue?vue&type=style&index=0&id=b53138b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53138b6",
  null
  
)

export default component.exports